var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseDrawerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H27.5V2.5H22.5H20H12.5V0Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5H12.5V5H7.5V2.5Z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 2.5H32.5V5H27.5V2.5Z",
    fill: "#8B8B8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H7.5V7.5H5V5Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5H35V7.5H32.5V5Z",
    fill: "#8B8B8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5H5V12.5H2.5V7.5Z",
    fill: "#8B8B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7.5H37.5V12.5H35V7.5Z",
    fill: "#8B8B8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5H2.5V27.5H0V12.5Z",
    fill: "#8B8B8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12.5H40V27.5H37.5V12.5Z",
    fill: "#8B8B8B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 21.25H18.75V23.75H16.25V21.25Z",
    fill: "#8B8B8B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75H21.25V21.25H18.75V18.75Z",
    fill: "#8B8B8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16.25H23.75V18.75H21.25V16.25Z",
    fill: "#8B8B8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13.75H26.25V16.25H23.75V13.75Z",
    fill: "#8B8B8B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 11.25H28.75V13.75H26.25V11.25Z",
    fill: "#8B8B8B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 23.75H16.25V26.25H13.75V23.75Z",
    fill: "#8B8B8B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 26.25H13.75V28.75H11.25V26.25Z",
    fill: "#8B8B8B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25H18.75V18.75H16.25V16.25Z",
    fill: "#8B8B8B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.75H16.25V16.25H13.75V13.75Z",
    fill: "#8B8B8B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25H13.75V13.75H11.25V11.25Z",
    fill: "#8B8B8B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 21.25H23.75V23.75H21.25V21.25Z",
    fill: "#8B8B8B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.75H26.25V26.25H23.75V23.75Z",
    fill: "#8B8B8B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 26.25H28.75V28.75H26.25V26.25Z",
    fill: "#8B8B8B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 27.5H5V32.5H2.5V27.5Z",
    fill: "#8B8B8B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27.5H37.5V32.5H35V27.5Z",
    fill: "#8B8B8B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5 32.5H7.5V35H5V32.5Z",
    fill: "#8B8B8B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5H35V35H32.5V32.5Z",
    fill: "#8B8B8B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 35H12.5V37.5H7.5V35Z",
    fill: "#8B8B8B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 35H32.5V37.5H27.5V35Z",
    fill: "#8B8B8B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 37.5H27.5V40H12.5V37.5Z",
    fill: "#8B8B8B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDrawerIcon);
export default __webpack_public_path__ + "static/media/closeDrawerIcon.bc868ef751a93988476334d18cd32cc4.svg";
export { ForwardRef as ReactComponent };